module.exports = __webpack_public_path__ + "img/stock6.226ae219.png";